export async function computeResourceFingerprint(key, items) {
  const payload = items
    .map((item) => {
      const segment = [item.id];

      // always include workspace_id in the fingerprint if it exists
      if (item.workspace_id != null) segment.push(item.workspace_id);

      // for the vast majority of resources, updated_at is enough to invalidate the fingerprint
      if (item.updated_at != null) segment.push(item.updated_at);

      // include sort_order for messages, mentions, and journal entries
      if (item.sort_order != null) segment.push(item.sort_order);

      // include shortcode for emojis cuz they dont have updated_at
      if (item.shortcode != null) segment.push(item.shortcode);

      // an emoji flips between offerable and resolve-only as chat membership changes,
      // and nothing else about the row moves when it does
      if (key === 'emojis' || key.startsWith('emojis:')) segment.push(item.resolve_only ? 1 : 0);

      // widget URLs can include a rotating JWT, so we treat them both as cache busters
      if (key === 'widgets') {
        segment.push(item.title);
        segment.push(item.default_title);
        segment.push(item.url);
        segment.push(item.preview_url);
        // The runtime URL is stable; this is the authoritative published document identity.
        segment.push(item.published_version);
        segment.push(item.botgeneratedcontent_token);
        segment.push(item.template_runtime_state);
        segment.push(item.official);
        segment.push(item.user_created);
        segment.push(item.icon_url);
        segment.push(JSON.stringify(item.message_actions || []));
      }

      // the agent-authoring capability is environment-driven, so it moves without updated_at
      if (key === 'workspaces') segment.push(item.widget_agent_authoring_enabled ? 1 : 0);

      // agent_chat title/status update async; share_key can be regenerated
      if (key === 'agent_chats') {
        segment.push(item.title);
        segment.push(item.status);
        segment.push(item.share_key);
      }

      return segment.join(':');
    })
    .sort()
    .join(',');
  const buffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(payload));
  const bytes = new Uint8Array(buffer);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}
